<template>
    <main id="mainContent" class="main-content bg-gray">
        <div class="page-container ptb-10">
            <div class="container" style="background-color: #fff;">
                <div class="section deals-header-area ptb-30">
                    <div v-for="(report,index) in reports" :key="index" class="trend-store-item media" style="margin-top: 5px;">
                        <div class="media-body">
                            <div class="post-module-6-item d-flex  wow fadeInUp  animated" style="visibility: visible; animation-name: fadeInUp;width: 580px;">
                                <span class="item-count vertical-align"><img :src="report.image_path" style="width: 252px;" v-if="report.image_path"></span>
                                <div class="single_post_text" style="margin-top: -3px;width: 580px;">
                                    <h4><a :href="'?report_id='+report.report_id+'#/report'" target="_blank">{{language=='zh'?report.title:report.title_en}}</a></h4>
                                    <div class="entry-meta meta-1 font-small color-grey" style="padding-top: 5px;">
                                        <span class="post-on" style="position: relative;float: right;margin-bottom: 15px;margin-right: 6px;">{{report.publish_date}}</span><span class="hit-count has-dot"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="space-15" style="height: 5px;"></div>
                        <div class="border_black" style="margin-bottom: 5px;margin-right: 5px;"></div>
                    </div>
                </div>
                <div class="section deals-header-area ptb-30">
                    <div class="row row-tb-20">
                        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="this.pageSize" :total="this.total" style="float:right;color: #717f86;">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import util from '../../common/js/util';
    import {getReportList} from '../../api/api';
    export default {
        data() {
            return {
                collapse: false,
                total: 0,
                page: 1,
                pageSize: 10,
                reports: [],
                language: 'zh'
            }
        },
        components: {
        },
        methods: {
            handleCurrentChange(val) {
                this.page = val;
                this.getReports();
            },
            getReports() {
                let para = {
                    page: this.page,
                    limit: this.pageSize,
                    query: {}
                };
                getReportList(para).then((res) => {
                    this.reports = res.data.data.reports;
                });
            },
        },
        created(){
        },
        mounted() {
            if (localStorage.getItem('carbon_emission_language')) {
                this.language = localStorage.getItem('carbon_emission_language');
            }
            this.getReports();
        }
    }
</script>
